// extracted by mini-css-extract-plugin
export default {"SearchPanel":"pk_a bhj_ea bhj_kb bhj_js bhj_a bhj_j bhj_sm bhj_sn","SearchPanel__icon":"pk_b bhj_vm bhj_hg bhj_ss bhj_uy","SearchPanel__input":"pk_c bhj_iz bhj_eb bhj_z"};